import { SecurityAttributes } from "../../utils/data/enums";

export const hasReadOnlyPermission = (multitenantFlag, hasSecurityAttribute) => {

    if (multitenantFlag && hasSecurityAttribute([SecurityAttributes.AdminSecurityRolesReadOnly]))
        return true;

    if (!multitenantFlag && hasSecurityAttribute([SecurityAttributes.SecurityRolesReadOnly]))
        return true;

    return false;
}

export const hasAddEditPermission = (multitenantFlag, hasSecurityAttribute) => {

    if (multitenantFlag && hasSecurityAttribute([SecurityAttributes.AdminSecurityRolesFullAccess]))
        return true;

    if (!multitenantFlag && hasSecurityAttribute([SecurityAttributes.SecurityRolesFullAccess]))
        return true;

    return false;
}